import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import TipoDecisaoService from '../../app/service/TipoDecisao'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'

class TipoDecisao extends React.Component {

  constructor(props) {
    super(props);

    this.tipoDecisaoService = new TipoDecisaoService();
    this.accept = this.accept.bind(this);
    this.renderFooterAlterarTipoDecisao = this.renderFooterAlterarTipoDecisao.bind(this);
    this.renderFooterCadastroTipoDecisao = this.renderFooterCadastroTipoDecisao.bind(this);
    this.acoes = this.acoes.bind(this);

    this.state = {
      //Cadastro
      codigo: '',
      nome: '',
      empresa: null,
      tipos: [],
      modalCadastro: false,
      modalAlterar: false,
      visivble: false,
      //Progresso
      classeDiv: 'hide'
    };
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  accept() {
    this.excluirTipoDecisao();
  }

  listarTiposDecisao = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoDecisaoService.listarTiposDecisao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  cadastrarTipoDecisao = async () => {
    this.setState({classeDiv: 'show'});
    
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:'Informe o nome do Tipo de Decisão', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado

    await this.tipoDecisaoService.cadastrarTipoDecisao({
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Tipos de Decisão', detail:'Tipo de Decisão cadastrada com sucesso', life: 4000});
      this.listarTiposDecisao();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalCadastro');
    this.setState({classeDiv: 'hide'});
  }

  async editar(tipo) {
    this.setState({classeDiv: 'show'});
    if(tipo != null) {
      this.tipoDecisaoService.consultarTipoDecisao(tipo.codigo)
        .then(response => {
          this.setState({codigo: response.data.codigo});
          this.setState({nome: response.data.nome});
          this.abrirModaAlterar('modalAlterar');
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:`${this.state.detail}`, life: 4000});
        });

        this.setState({classeDiv: 'hide'});
    }

    this.setState({classeDiv: 'hide'});
  }

  alterarTipoDecisao = async() => {
    this.setState({classeDiv: 'show'});
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:'Informe a nome do Tipo de Decisão', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado

    await this.tipoDecisaoService.alterarTipoDecisao({
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Tipos de Decisão', detail:'Tipo de Decisão alterado com sucesso', life: 4000});
      this.listarTiposDecisao();
      this.fecharModalCadastro('modalAlterar');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:`${this.state.detail}`, life: 4000});
    });

    this.setState({classeDiv: 'hide'});

  }

  confirmaExclusao(tipo) {
    this.setState({codigo: tipo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Tipo de Decisão?',
        header: 'Exclusão de Tipo de Decisão',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirTipoDecisao = async() => {
    this.setState({classeDiv: 'show'});
    await this.tipoDecisaoService.excluirTipoDecisao(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Decisão', detail:'Tipo de Decisão excluída com sucesso', life: 4000});
        this.listarTiposDecisao();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Decisão', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroTipoDecisao(name) {
    return (
        <div>
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTipoDecisao}/> 
        </div>
    );
  }

  renderFooterAlterarTipoDecisao(name) {
    return (
        <div>
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTipoDecisao}/> 
        </div>
    );
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Tipo de Decisão" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Decisão" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.listarTiposDecisao();  
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          {/**Cadastro de Tipo de Decisão */}
          <Dialog header="Cadastro de Tipo de Decisão"
                    visible={this.state.modalCadastro} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTipoDecisao('modalCadastro')} 
                    onHide={() => this.fecharModalCadastro('modalCadastro')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeStatus">Nome</label>
                        <InputText id="nomeStatus" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Tipo de Decisão */}
          <Dialog header="Alterar Tipo de Decisão"
                    visible={this.state.modalAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTipoDecisao('modalAlterar')} 
                    onHide={() => this.fecharModalCadastro('modalAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeStatusAlterar">Nome</label>
                        <InputText id="nomeStatusAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <ConfirmDialog visible={this.state.visible} 
                         onHide={() => this.setState({ visible: false })} 
                         message="Are you sure you want to proceed?"
                         header="Confirmation"
                         icon="pi pi-exclamation-triangle" 
                         accept={() => this.excluirTipoDecisao} 
                         reject={() => this.setState({visible: false})}/>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fab fa-codepen"></i>
                        <span> Tipos de Decisão</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalCadastro')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    <Progresso classeSecundaria={this.state.classeDiv}/>
                    </div>
                    <DataTable value={this.state.tipos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column key="codigo"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TipoDecisao.contextType = AuthContext;
export default withRouter (TipoDecisao)

